import React from 'react'
import { T } from '@transifex/react'
import { Icon, Text } from '@lightspeed/design-system-react'
import { Currency } from '@vend/business-components'

interface PaymentRequestOverpaymentWarningProps {
  /** Number of pending payment requests */
  pendingCount: number
  /** Total amount of pending payment requests in dollars */
  totalPendingAmount: number
  /** Threshold amount in dollars (sale total - payment request total) */
  thresholdAmount: number
}

export const PaymentRequestOverpaymentWarning: React.FC<PaymentRequestOverpaymentWarningProps> = ({
  pendingCount,
  totalPendingAmount,
  thresholdAmount,
}) => {
  return (
    <div className="payment-request-overpayment-warning-banner">
      <Icon icon="fa-exclamation-triangle" />
      <Text style={{ lineHeight: '1.5' }}>
        <T
          _str="{count, plural, one {You have {count} pending payment request totaling {totalAmount}. Collecting any amount above {threshold} will cancel the payment request.} other {You have {count} pending payment requests totaling {totalAmount}. Collecting any amount above {threshold} will cancel all the payment requests.}}"
          _context="Payment request overpayment warning"
          count={pendingCount}
          totalAmount={<Currency value={totalPendingAmount} />}
          threshold={<Currency value={thresholdAmount} />}
        />
      </Text>
    </div>
  )
}
